import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 42E3BF4B-FFE9-449F-AFEE-66F565602A9B
 * name chart-multiple
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-multiple.svg
 * tags
 * - Math 
 */
export const ChartMultipleIcon = createSvgIcon(<><path d="M22 16V18H6V2H8V13.57L13.71 4.57L16.87 6.68L19.29 4.26L20.71 5.68L17.13 9.29L14.29 7.4L8.82 16M4 20V4H2V22H22V20Z" /></>, 'ChartMultipleIcon');
export default ChartMultipleIcon